export const AllowedRoutes = ["/", "/login", "/register"];

const PROJECT_TITTLE = "Water Logging Monitor System";

export const MetaTags = [
  {
    path: "/",
    viewPath: "",
    title: `${PROJECT_TITTLE}`,
    description: "",
  },
  {
    path: "/dashboard",
    viewPath: "",
    title: `Dashboard - ${PROJECT_TITTLE}`,
    description: "",
  },

  {
    path: "/zones",
    viewPath: "",
    title: `Zones - ${PROJECT_TITTLE}`,
    description: "",
  },
  {
    path: "/wards",
    viewPath: "",
    title: `Wards - ${PROJECT_TITTLE}`,
    description: "",
  },

  {
    path: "/admin-users",
    viewPath: "",
    title: `Admin Users - ${PROJECT_TITTLE}`,
    description: "",
  },
  {
    path: "/roles",
    viewPath: "",
    title: `Roles - ${PROJECT_TITTLE}`,
    description: "",
  },
  {
    path: "/permissions",
    viewPath: "",
    title: `Permissions - ${PROJECT_TITTLE}`,
    description: "",
  },
  {
    path: "/config",
    viewPath: "",
    title: `Config - ${PROJECT_TITTLE}`,
    description: "",
  },
  {
    path: "/profile",
    viewPath: "",
    title: `My Profile - ${PROJECT_TITTLE}`,
    description: "",
  },
  {
    path: "/locations",
    viewPath: "",
    title: `Locations - ${PROJECT_TITTLE}`,
    description: "",
  },
  {
    path: "/devices",
    viewPath: "",
    title: `Devices - ${PROJECT_TITTLE}`,
    description: "",
  },
  {
    path: "/device-ota",
    viewPath: "",
    title: `Device OTA Upload - ${PROJECT_TITTLE}`,
    description: "",
  },
  {
    path: "/device-ota/monitor",
    viewPath: "",
    title: `OTA Monitor - ${PROJECT_TITTLE}`,
    description: "",
  },
];

export const sideMenuList = [
  {
    name: "Dashboard",
    permissions: ["dashboard"],
    icon: (isActive) =>
      `<svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 4.5C5.17157 4.5 4.5 5.17157 4.5 6V8.25C4.5 9.07843 5.17157 9.75 6 9.75H8.25C9.07843 9.75 9.75 9.07843 9.75 8.25V6C9.75 5.17157 9.07843 4.5 8.25 4.5H6ZM3 6C3 4.34315 4.34315 3 6 3H8.25C9.90685 3 11.25 4.34315 11.25 6V8.25C11.25 9.90685 9.90685 11.25 8.25 11.25H6C4.34315 11.25 3 9.90685 3 8.25V6Z"
          fill=${isActive ? "#312F91" : "#FFFFFF"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 14.25C5.17158 14.25 4.5 14.9216 4.5 15.75V18C4.5 18.8284 5.17158 19.5 6 19.5H8.25C9.07842 19.5 9.75 18.8284 9.75 18V15.75C9.75 14.9216 9.07842 14.25 8.25 14.25H6ZM3 15.75C3 14.0932 4.34314 12.75 6 12.75H8.25C9.90686 12.75 11.25 14.0932 11.25 15.75V18C11.25 19.6568 9.90686 21 8.25 21H6C4.34314 21 3 19.6568 3 18V15.75Z"
          fill=${isActive ? "#312F91" : "#FFFFFF"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.7501 4.5C14.9217 4.5 14.2501 5.17158 14.2501 6V8.25C14.2501 9.07842 14.9217 9.75 15.7501 9.75H18.0001C18.8285 9.75 19.5001 9.07842 19.5001 8.25V6C19.5001 5.17158 18.8285 4.5 18.0001 4.5H15.7501ZM12.7501 6C12.7501 4.34314 14.0933 3 15.7501 3H18.0001C19.6569 3 21.0001 4.34314 21.0001 6V8.25C21.0001 9.90686 19.6569 11.25 18.0001 11.25H15.7501C14.0933 11.25 12.7501 9.90686 12.7501 8.25V6Z"
          fill=${isActive ? "#312F91" : "#FFFFFF"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.7501 14.25C14.9217 14.25 14.2501 14.9216 14.2501 15.75V18C14.2501 18.8284 14.9217 19.5 15.7501 19.5H18.0001C18.8285 19.5 19.5001 18.8284 19.5001 18V15.75C19.5001 14.9216 18.8285 14.25 18.0001 14.25H15.7501ZM12.7501 15.75C12.7501 14.0932 14.0933 12.75 15.7501 12.75H18.0001C19.6569 12.75 21.0001 14.0932 21.0001 15.75V18C21.0001 19.6568 19.6569 21 18.0001 21H15.7501C14.0933 21 12.7501 19.6568 12.7501 18V15.75Z"
          fill=${isActive ? "#312F91" : "#FFFFFF"}
        />
      </svg>`,
    subItems: [],
    path: "/dashboard",
  },

  {
    name: "Master",
    permissions: [
      "zones-list",
      "wards-list",
      "state-list",
      "city-list",
    ],
    icon: (isActive) =>
      `<svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_361_470)">
          <path
            d="M23.9691 21.5992L21.4812 12.8804C21.3825 12.5345 21.0664 12.296 20.7068 12.296H14.9857C16.1335 10.7469 17.2508 8.70536 17.2508 6.62697C17.2508 3.73064 14.8954 1.37427 12.0001 1.37427C9.10471 1.37427 6.74922 3.73064 6.74922 6.62697C6.74922 8.70544 7.86648 10.7469 9.01436 12.296H3.29313C2.93353 12.296 2.61749 12.5345 2.51875 12.8804L0.0308985 21.5992C-0.0383543 21.8421 0.0102115 22.1036 0.162454 22.3053C0.314617 22.507 0.552597 22.6256 0.805285 22.6256H23.1947C23.4474 22.6256 23.6854 22.507 23.8375 22.3053C23.9898 22.1036 24.0383 21.8421 23.9691 21.5992ZM12.0001 2.98486C14.0072 2.98486 15.6402 4.61872 15.6402 6.62689C15.6402 9.32169 13.1251 12.1593 12.0001 13.2937C10.875 12.1593 8.35982 9.32169 8.35982 6.62689C8.35982 4.61872 9.99287 2.98486 12.0001 2.98486ZM10.3529 13.9068C10.9568 14.5595 11.4097 14.9629 11.4678 15.0142C11.6199 15.1481 11.8099 15.2151 12.0001 15.2151C12.1902 15.2151 12.3803 15.1481 12.5324 15.0142C12.5905 14.9629 13.0434 14.5595 13.6472 13.9068H20.0992L20.323 14.6912L17.2079 17.2871L3.6402 14.8203L3.90097 13.9068H10.3529ZM6.16134 21.0149V16.9157L15.5952 18.6311L12.7345 21.0149H6.16134ZM3.19608 16.3767L4.55067 16.6229V21.015H1.8726L3.19608 16.3767ZM15.2504 21.0149L20.8062 16.385L22.1274 21.0149H15.2504Z"
            fill=${isActive ? "#312F91" : "#FFFFFF"}
          />
          <path
            d="M14.1665 6.62708C14.1665 5.42619 13.1946 4.44922 12 4.44922C10.8053 4.44922 9.83325 5.42619 9.83325 6.62708C9.83325 7.82782 10.8052 8.80495 12 8.80495C13.1946 8.80495 14.1665 7.82782 14.1665 6.62708ZM11.444 6.62708C11.444 6.31428 11.6935 6.05981 12 6.05981C12.3066 6.05981 12.5559 6.3142 12.5559 6.62708C12.5559 6.93998 12.3066 7.19436 12 7.19436C11.6935 7.19428 11.444 6.93989 11.444 6.62708Z"
            fill=${isActive ? "#312F91" : "#FFFFFF"}
          />
        </g>
        <defs>
          <clipPath id="clip0_361_470">
            <rect
              width="24"
              height="24"
              fill=${isActive ? "#312F91" : "#FFFFFF"}
            />
          </clipPath>
        </defs>
      </svg>`,
    subItems: [
      {
        name: "States",
        icon: "",
        path: "/states",
        permission: "state-list",
      },

      {
        name: "Cities",
        icon: "",
        path: "/cities",
        permission: "city-list",
      },
      {
        name: "Zones",
        icon: "",
        path: "/zones",
        permission: "zones-list",
      },
      {
        name: "Wards",
        icon: "",
        path: "/wards",
        permission: "wards-list",
      },
    ],
    path: "",
  },
  {
    name: "Admin",
    permissions: ["admin-user-list", "role-list", "permission-list", "config-list"],
    icon: (isActive) =>
      `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" stroke=${
        isActive ? "#312F91" : "#FFFFFF"
      } stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M20.5899 22C20.5899 18.13 16.7399 15 11.9999 15C7.25991 15 3.40991 18.13 3.40991 22" stroke=${
        isActive ? "#312F91" : "#FFFFFF"
      } stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`,
    subItems: [
      {
        name: "Admin Users",
        icon: "",
        path: "/admin-users",
        permission: "admin-user-list",
      },
      {
        name: "Roles",
        icon: "",
        path: "/roles",
        permission: "role-list",
      },
      {
        name: "Permissions",
        icon: "",
        path: "/permissions",
        permission: "permission-list",
      },
      {
        name: "Config",
        icon: "",
        path: "/config",
        permission: "config-list",
      },
    ],
    path: "",
  },
  {
    name: "Locations",
    permissions: [
      "locations-list",
      "locations-view",
      "locations-create",
      "locations-edit",
      "locations-delete",
    ],
    icon: (isActive) =>
      `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22 9.00002V15C22 17.5 21.5 19.25 20.38 20.38L14 14L21.73 6.27002C21.91 7.06002 22 7.96002 22 9.00002Z" stroke=${
            isActive ? "#312F91" : "#FFFFFF"
          } stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M21.73 6.27L6.26999 21.73C3.25999 21.04 2 18.96 2 15V9C2 4 4 2 9 2H15C18.96 2 21.04 3.26 21.73 6.27Z" stroke=${
            isActive ? "#312F91" : "#FFFFFF"
          } stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M20.38 20.38C19.25 21.5 17.5 22 15 22H9.00003C7.96003 22 7.06002 21.91 6.27002 21.73L14 14L20.38 20.38Z" stroke=${
            isActive ? "#312F91" : "#FFFFFF"
          } stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M6.24002 7.98021C6.92002 5.05021 11.32 5.05021 12 7.98021C12.39 9.70021 11.31 11.1602 10.36 12.0602C9.67001 12.7202 8.58003 12.7202 7.88003 12.0602C6.93003 11.1602 5.84002 9.70021 6.24002 7.98021Z" stroke=${
            isActive ? "#312F91" : "#FFFFFF"
          } stroke-width="1.5"/>
          <path d="M9.0946 8.7002H9.10359" stroke=${
            isActive ? "#312F91" : "#FFFFFF"
          } stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`,
    path: "/locations",
    subItems: [],
  },

  {
    name: "Devices",
    permissions: [
      "device-list",
      "device-view",
      "device-create",
      "device-edit",
      "device-delete",
    ],
    icon: (isActive) =>
      `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 4H17V9H7V4Z" stroke=${isActive ? "#312F91" : "#FFFFFF"} stroke-width="1.5" stroke-linejoin="round"/>
        <path d="M12 9V19" stroke=${isActive ? "#312F91" : "#FFFFFF"} stroke-width="1.5" stroke-linecap="round"/>
        <path d="M9 20H15" stroke=${isActive ? "#312F91" : "#FFFFFF"} stroke-width="1.5" stroke-linecap="round"/>
      </svg>`,
    subItems: [],
    path: "/devices",
  },

  {
    name: "Device OTA",
    permissions: [
      "device-ota-list",
      "device-ota-trigger",
      "device-ota-manage",
    ],
    icon: (isActive) =>
      `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 3L4 7V11C4 16 7.5 19.5 12 21C16.5 19.5 20 16 20 11V7L12 3Z" stroke=${isActive ? "#312F91" : "#FFFFFF"} stroke-width="1.5" stroke-linejoin="round"/>
        <path d="M12 8V13" stroke=${isActive ? "#312F91" : "#FFFFFF"} stroke-width="1.5" stroke-linecap="round"/>
        <path d="M9.5 10.5L12 13L14.5 10.5" stroke=${isActive ? "#312F91" : "#FFFFFF"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`,
    subItems: [],
    path: "/device-ota",
  },
];

export const ROLE = [
  {
    value: "admin",
    label: "Admin",
  },
  {
    value: "user",
    label: "User",
  },
  {
    value: "superadmin",
    label: "Super Admin",
  },
];
